"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lms = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/Checklist/Checklist");
const ChecklistControls_1 = require("../../../TdWebtoolkitControls/controls/Checklist/ChecklistControls");
require("../../../TdWebtoolkitControls/controls/Menu/MethodManager");
const synerisMethods_1 = require("../../../TdWebtoolkitControls/controls/Menu/synerisMethods");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
require("../SynView");
const lmsModel_1 = require("./lmsModel");
require("./ScormApi");
const $ = require("jquery");
let r_css = require("./lms.tmpl.less");
const m = require("../SynView");
const scormApi = require("../../views/lms/ScormApi");
let r_tagOverviewTemplate = require("./lms_tagOverview.tmpl.htm");
let r_mainTemplate = require("./lms_main.tmpl.htm");
let r_scormTemplate = require("./lms_scorm.tmpl.htm");
class lms extends m.SynView {
    //#endregion MEMBER letIABLES
    //#region CONTRUCTORS
    constructor() {
        super();
        this.m_hasMenu = false;
        this.m_externalChangeEventRegistered = false;
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member letiables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-graduation-cap";
    }
    getParametersFromUrl() {
        this.m_tag = typeof ($.address.parameter("tag")) === "undefined" ? undefined : decodeURIComponent($.address.parameter("tag"));
        this.m_scormHistoryObject = typeof ($.address.parameter("scorm")) === "undefined" ? undefined : decodeURIComponent($.address.parameter("scorm"));
        this.m_scormReadOnly = false;
        let scormLesson = $.address.parameter("scormLesson");
        if (scormLesson) {
            this.m_scormHistoryObject = scormLesson;
            this.m_scormReadOnly = true;
        }
        this.m_searchText = typeof ($.address.parameter("search")) === "undefined" ? undefined : decodeURIComponent($.address.parameter("search"));
    }
    renderContents() {
        let that = this;
        this.m_$lmsPane = this.m_$container.find(".lmsPane");
        if (!that.m_externalChangeEventRegistered) {
            that.m_externalChangeEventRegistered = true;
            $.address.externalChange((evt) => {
                if (evt.value === "/lms" || evt.value.indexOf("/lms?") === 0) {
                    that.getParametersFromUrl();
                    that.renderContents();
                }
            });
            $.address.internalChange((evt) => {
                if (evt.value === "/lms" || evt.value.indexOf("/lms?") === 0) {
                    that.getParametersFromUrl();
                    that.renderContents();
                }
            });
        }
        if (that.m_scormHistoryObject)
            that.createScormPage();
        else if (that.tagsEnabled && !that.m_tag && !that.m_searchText)
            that.createOverviewPage();
        else
            that.createMainPage(that.m_searchText);
    }
    forceRefresh(modifications) { }
    get tagsEnabled() {
        return Utilities_1.synUtil.Configs.getValue("lms.enabletags", "N") === "Y";
    }
    scormFinished() {
        let scormApi = window.API;
        if (scormApi)
            scormApi.ignoreFurtherCommits = true;
        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("lms.scormfinished"));
        window.location.hash = "#/lms";
    }
    createScormPage() {
        let that = this;
        let template = kendo.template(r_scormTemplate);
        window.synUtil_endAjaxProgress = Utilities_1.synUtil.endAjaxProgress;
        this.m_$lmsPane.html(template({
            backButtonText: Utilities_1.synUtil.Strings.getValue("lms.backbuttontext")
        }));
        let $scormFrame = that.m_$lmsPane.find(".scormFrame");
        let startInfoUrl = Utilities_1.synUtil.getWSUrl("LmsScormStartInfo") + that.m_scormHistoryObject;
        if (that.m_scormReadOnly)
            startInfoUrl += "?readonly=true";
        Utilities_1.synUtil.beginAjaxProgress();
        Utilities_1.synUtil.getAJAXData({
            url: startInfoUrl,
            done(scormStartInfo) {
                window.API = new scormApi.ScormApi(that.m_scormHistoryObject, that.m_scormReadOnly, scormStartInfo.userId, scormStartInfo.userName, true, "normal", scormStartInfo.launchData, scormStartInfo.scoData);
                window.TdScormFinished = that.scormFinished;
                let url = $.address.baseURL() + "/ScormRuntime/" + scormStartInfo.lessonId + "/" + scormStartInfo.startPath;
                $scormFrame.focus();
                Utilities_1.synUtil.beginAjaxProgress();
                setTimeout(() => { $scormFrame.attr("src", url).focus(); }, 250);
            },
            cleanUp: () => { Utilities_1.synUtil.endAjaxProgress(); }
        });
    }
    createOverviewPage() {
        let that = this;
        Utilities_1.synUtil.beginAjaxProgress();
        Utilities_1.synUtil.getAJAXData({
            method: "GET",
            url: Utilities_1.synUtil.getWSUrl("LmsTags"),
            done(tags) {
                let template = kendo.template(r_tagOverviewTemplate);
                tags.sort((t1, t2) => t1.name.localeCompare(t2.name));
                let percentCompleteFmt = Utilities_1.synUtil.Strings.getValue("lms.percentcompleteformat");
                let optionalLessonsFmt = Utilities_1.synUtil.Strings.getValue("lms.optionallessonsformat");
                $.each(tags, (idx, tag) => {
                    tag.percentCompleteString = kendo.format(percentCompleteFmt, tag.lessonCount, tag.percentComplete);
                    if (tag.optionalLessonCount)
                        tag.optionalLessonsString = kendo.format(optionalLessonsFmt, tag.optionalLessonCount);
                });
                that.m_$lmsPane.html(template({
                    tags,
                    tagOverViewTitle: Utilities_1.synUtil.Strings.getValue("lms.tagoverview"),
                    searchBoxPlaceHolder: Utilities_1.synUtil.Strings.getValue("lms.searchboxplaceholder"),
                }));
                that.createSearchBox();
                that.m_$lmsPane.find(".lmsTag").each((idx, elem) => {
                    $(elem).off("click").on("click", function () {
                        window.location.hash = "#/lms?tag=" + encodeURIComponent($(elem).attr("data-tag"));
                    });
                });
                that.m_$lmsPane.find(".progressBar").each((idx, elem) => {
                    let $elem = $(elem);
                    that.createProgressBar($elem, parseInt(($elem.attr("data-percentage") || "0"), 10));
                });
            },
            cleanUp() {
                Utilities_1.synUtil.endAjaxProgress();
            }
        });
    }
    search() {
        let searchText = this.m_$lmsPane.find("div.searchBox").text();
        if (searchText)
            $.address.parameter("search", searchText, false);
    }
    // valFrom and valTo are h, s, or v components (both the same type).+
    // normalizedScale is any value inside the interval [0,1].
    hsvValueBetween(valFrom, valTo, normalizedScale) {
        return valFrom + (valTo - valFrom) * normalizedScale;
    }
    createProgressBar($elem, percentage) {
        let trafficRed = "#D99494";
        let trafficYellow = "#ECDBA5";
        let trafficGreen = "#9DC092";
        let resultColorHex = trafficRed;
        if (0 <= percentage && percentage <= 100) {
            let normalized = (percentage - (percentage > 50 ? 50 : 0)) / 50;
            let from = percentage > 50 ? trafficYellow : trafficRed;
            let to = percentage > 50 ? trafficGreen : trafficYellow;
            let hsvFrom = kendo.parseColor(from, false).toHSV();
            let hsvTo = kendo.parseColor(to, false).toHSV();
            let hsvBetween = {
                h: hsvFrom.h + (hsvTo.h - hsvFrom.h) * normalized,
                s: hsvFrom.s + (hsvTo.s - hsvFrom.s) * normalized,
                v: hsvFrom.v + (hsvTo.v - hsvFrom.v) * normalized
            };
            resultColorHex = "#" + kendo.Color.fromHSV(this.hsvValueBetween(hsvFrom.h, hsvTo.h, normalized), this.hsvValueBetween(hsvFrom.s, hsvTo.s, normalized), this.hsvValueBetween(hsvFrom.v, hsvTo.v, normalized), 1).toHex();
        }
        let hsv = kendo.parseColor(resultColorHex, false).toHSV();
        let borderColorHex = "#" + kendo.Color.fromHSV(hsv.h, hsv.s, hsv.v * 0.75, 1).toHex();
        let pb = $elem
            .attr("title", kendo.toString(percentage, "n2") + "%")
            .css("border-color", borderColorHex)
            .kendoProgressBar({
            min: 0,
            max: 100,
            showStatus: false,
            type: "value",
            animation: {
                duration: 400
            }
        }).data("kendoProgressBar");
        pb.value(Math.max(percentage, 5));
        $elem.find(".k-state-selected").css("background-color", resultColorHex);
    }
    createMainPage(searchText) {
        let that = this;
        let createLessons = function (lessons) {
            let template = kendo.template(r_mainTemplate);
            lessons.sort((l1, l2) => (l1.LessonInstance.name.valueToString() || "").localeCompare(l2.LessonInstance.name.valueToString() || ""));
            let isMandatoryPredicate = (item) => item.Mandatory;
            that.m_$lmsPane.html(template({
                enableBackButton: that.tagsEnabled || searchText,
                mandatoryLessons: $.grep(lessons, isMandatoryPredicate),
                optionalLessons: $.grep(lessons, isMandatoryPredicate, true),
                backButtonText: Utilities_1.synUtil.Strings.getValue("lms.backbuttontext"),
                mandatoryLessonsHeader: Utilities_1.synUtil.Strings.getValue("lms.mandatorylessonsheader"),
                optionalLessonsHeader: Utilities_1.synUtil.Strings.getValue("lms.optionallessonsheader"),
                warnhistoryObjectObsolete: Utilities_1.synUtil.Strings.getValue("lms.warnhistoryobjectobsolete"),
                isRead: Utilities_1.synUtil.Strings.getValue("lms.isread"),
                noSearchResults: Utilities_1.synUtil.Strings.getValue("searchnoresults")
            }));
            that.createSearchBox();
            that.m_$lmsPane.find("a.readLink").on("click", function (evt) {
                evt.stopPropagation();
                let $lesson = $(this).closest(".lmsLesson");
                let lmsUpdateLessonCompletionCallBack = () => {
                    Utilities_1.synUtil.beginAjaxProgress();
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("LmsUpdateLessonCompletion") + $lesson.attr("data-historyobjectid"),
                        requestData: { completion: 2 },
                        done() {
                            that.renderContents();
                        },
                        cleanUp: () => {
                            Utilities_1.synUtil.endAjaxProgress();
                        }
                    });
                };
                let lessionId = $lesson.attr("data-lessonid");
                let historyobjectId = $lesson.attr("data-historyobjectid");
                Utilities_1.synUtil.beginAjaxProgress();
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ChecklistCreateQuestionnaire"),
                    requestData: {
                        lessionid: lessionId,
                        historyobjectid: historyobjectId,
                    },
                    done(questionInstance) {
                        if (!$.isEmptyObject(questionInstance)) {
                            let markup = require("../../../TdWebtoolkitControls/templates/questionnaire.tmpl.html");
                            // Create Window
                            let windowData = Utilities_1.synUtil.popupWindow({
                                title: Utilities_1.synUtil.Strings.getValue("questionnairetitle"),
                                actions: ["Maximize", "Close"],
                                width: 1024,
                                height: 768,
                                resizable: true,
                                modal: true,
                                synDesktopAware: true
                            });
                            // Initialize contents
                            let configData = {
                                synUtil: Utilities_1.synUtil,
                                windowID: "popup_" + windowData.guid,
                                checklistId: "checklist_" + windowData.guid,
                                prevButtonId: "prevButton_" + windowData.guid,
                                nextButtonId: "nextButton_" + windowData.guid,
                                checkButtonId: "checkButton_" + windowData.guid,
                                okButtonId: "okButton_" + windowData.guid,
                            };
                            // Create HTML from template
                            let template = kendo.template(markup);
                            windowData.contentDiv.html(template(configData));
                            let checklistPane = $("#" + configData.checklistId);
                            checklistPane.synChecklist();
                            $("#" + configData.checkButtonId).on("click", function () {
                                let newInst = checklistPane.synChecklist("getInstance");
                                let requestOptions = {
                                    instance: JSON.stringify(newInst),
                                    lessionid: lessionId,
                                    historyobjectid: historyobjectId,
                                };
                                let checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistCheckQuestionnaire");
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: checklistInstanceUrl,
                                    requestData: requestOptions,
                                    done(result) {
                                        $("#" + configData.prevButtonId).hide();
                                        $("#" + configData.nextButtonId).hide();
                                        $("#" + configData.checkButtonId).hide();
                                        $("#" + configData.okButtonId).show();
                                        $(document).keypress(function (e) {
                                            if (e.which === 13)
                                                $("#" + configData.okButtonId).trigger("click");
                                        });
                                        checklistPane.synChecklist("showResult", result);
                                        if (result["passed"])
                                            lmsUpdateLessonCompletionCallBack();
                                    },
                                    cleanUp: () => {
                                        Utilities_1.synUtil.endAjaxProgress();
                                    }
                                });
                            });
                            $("#" + configData.nextButtonId).on("click", function () {
                                checklistPane.synChecklist("selectNext", configData);
                            });
                            $("#" + configData.prevButtonId).on("click", function () {
                                checklistPane.synChecklist("selectPrevious", configData);
                            });
                            let isClosing = false;
                            $("#" + configData.okButtonId).on("click", function () {
                                isClosing = true;
                                $("#" + configData.windowID).data("kendoWindow").close();
                            });
                            $("#" + configData.windowID).data("kendoWindow").bind("close", function (e) {
                                if (!isClosing && !window.confirm(Utilities_1.synUtil.Strings.getValue("askclosequestionnaire")))
                                    e.preventDefault();
                            });
                            checklistPane.synChecklist("setInstance", questionInstance, configData, ChecklistControls_1.ChecklistMode.Editor | ChecklistControls_1.ChecklistMode.Questionnaire, false);
                        }
                        else
                            lmsUpdateLessonCompletionCallBack();
                    },
                    cleanUp: () => {
                        Utilities_1.synUtil.endAjaxProgress();
                    }
                });
            });
            that.m_$lmsPane.find(".lmsLesson").off("click").on("click", function () {
                let $lesson = $(this);
                let lessonId = $lesson.attr("data-lessonid");
                let isScorm = "true" === $lesson.attr("data-isscorm");
                let completion = parseInt($lesson.attr("data-completion"), 10);
                that.openLesson(lessonId, ($lesson.attr("data-historyobjectid") || undefined), isScorm, completion);
            });
        };
        if (searchText) {
            Utilities_1.synUtil.beginAjaxProgress();
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("LmsLessonsSearch"),
                requestData: { searchText },
                done(lessonsJSON) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let lessons = yield lmsModel_1.LMSLesson.fromJSONArray(lessonsJSON);
                        createLessons(lessons);
                        that.m_$lmsPane.find(".tagHeader>h2").text("Suchergebnisse");
                    });
                },
                cleanUp() {
                    Utilities_1.synUtil.endAjaxProgress();
                }
            });
        }
        else {
            Utilities_1.synUtil.beginAjaxProgress();
            let url = Utilities_1.synUtil.getWSUrl("LmsLessons");
            if (that.m_tag)
                url += kendo.format("?tag={0}", encodeURIComponent(that.m_tag));
            Utilities_1.synUtil.getAJAXData({
                method: "GET",
                url,
                done(lessonsJSON) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let lessons = yield lmsModel_1.LMSLesson.fromJSONArray(lessonsJSON);
                        createLessons(lessons);
                        that.m_$lmsPane.find(".tagHeader>h2").text(that.m_tag || "") + ": " + Utilities_1.synUtil.Strings.getValue("lms.captionmandatory");
                    });
                },
                cleanUp() {
                    Utilities_1.synUtil.endAjaxProgress();
                }
            });
        }
    }
    createSearchBox() {
        let that = this;
        that.m_$lmsPane.find("div.searchBox")
            .text(that.m_searchText || "")
            .off("keypress").on("keypress", (e) => {
            if (e.which === 13)
                that.search();
        })
            .off("blur").on("blur", () => { that.m_$lmsPane.find("div.searchBox").find("br").remove(); });
        that.m_$lmsPane.find("div.searchButton").off("click").on("click", function () { that.search(); });
    }
    openLesson(lessonId, historyObjectId, isScorm, completion) {
        let that = this;
        if (isScorm) {
            $.address.autoUpdate(false);
            if (historyObjectId)
                $.address.parameter("scorm", historyObjectId, false);
            else
                $.address.parameter("scormLesson", lessonId, false);
            $.address.parameter("tag", undefined, false);
            $.address.update();
            $.address.autoUpdate(true);
        }
        else {
            if (!historyObjectId || completion === 2)
                synerisMethods_1.synerisMethods.cefunc["26"].impl([lessonId], undefined, undefined, undefined);
            else {
                Utilities_1.synUtil.beginAjaxProgress();
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("LmsUpdateLessonCompletion") + historyObjectId,
                    requestData: { completion: 1 },
                    done() {
                        // We need to executed renderContents() as continuation of cefunc.26, because
                        // if SynerisWorkspace is enabled, cefunc.26 will result in a location.assign()
                        // call (to synerisws://-URI handling the document) which will abort the in-flight
                        // GET request to LMS/Lessons, resulting in an XHR error ("Status code 'error'
                        // requesting WSProxy.axd?synws=LMS/Lessons"), provided both (location.assign()
                        // and GET request to LMS/Lessons) coincide just at the right time.
                        synerisMethods_1.synerisMethods.cefunc["26"].impl([lessonId], undefined, undefined, () => {
                            that.renderContents();
                        });
                    },
                    cleanUp: () => { Utilities_1.synUtil.endAjaxProgress(); }
                });
            }
        }
    }
    createNewMenu() {
    }
    setSelectionContext({}) {
    }
}
exports.lms = lms;
